import React from 'react';
import { Route, Redirect } from 'react-router-dom';

const PrivateRoute = ({ component: Component, ...rest }) => {
    // 检查用户是否已登录（通过是否存在有效的authToken和authUserName判断）
    const isAuthenticated = !!(localStorage.authToken && localStorage.authUserName);
    const roles = (localStorage.authRoleList || '').split(",")

    return (
        <Route
            {...rest}
            render={props =>
                isAuthenticated && roles && roles.includes('1') ? (
                    <Component {...props} />
                ) : (
                    <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
                )
            }
        />
    );
};

export default PrivateRoute;